<div class="product-add" fxLayout="column" fxLayoutGap="15px" [formGroup]="productForm">
  <div class="buttons" fxLayout="row" fxLayoutGap="15px">
    <button tabindex="-1" (click)="sendForm()" [class.spinner]="processingRequest"
            [disabled]="!productForm.valid || processingRequest"
            mat-stroked-button color="primary">
      <mat-icon>save</mat-icon> <span> Zapisz</span>
    </button>
    <button tabindex="-1" (click)="cancel()" mat-stroked-button color="warn">
      <mat-icon>cancel</mat-icon> <span> Anuluj</span>
    </button>

    <button *ngIf="productObject?.filename" tabindex="-1" (click)="deleteImage()" mat-stroked-button color="warn">
      <mat-icon>cancel</mat-icon> <span> Usuń zdjęcie</span>
    </button>
  </div>

  <div fxFlex="100" fxLayout="row" fxLayoutGap="10px">
    <mat-card fxFlex="50">
      <div fxLayout="column" fxLayoutGap="10px">
        <h3>Dane produktu</h3>

        <div>
          <div (click)="setImage()" class="user-avatar" *ngIf="productObject?.filename"
               matRipple
               [matRippleCentered]="false"
               [matRippleDisabled]="false"
               [matRippleUnbounded]="false"
               [matRippleRadius]="10"
               [matRippleColor]="'grey'"
               style="cursor: pointer; display: inline-block;">
            <img src="/rest/crm/product/{{productObject.uuid}}/image?{{imgCnt}}" alt="Zdjęcie" height="60"/>
          </div>

          <button *ngIf="!productObject?.filename && productObject?.uuid"
                  mat-stroked-button
                  type="button"
                  (click)="setImage()">
            <mat-icon>add_a_photo</mat-icon> <span> Dodaj</span>
          </button>

          <div>
            <span fxFlex></span>
          </div>
          <input #imageSelect type="file" style="display: none" [formControl]="imageSelectControl"
                 accept=".jpg,.gif,.png,.jpeg"/>
        </div>

        <div fxLayout="row" fxLayoutGap="10px">
          <app-dynamic-dict fxFlex="50" label="Kategoria" [required]="true"
                            [control]="categoryControl"
                            [dictType]="DYNAMIC_DICTIONARY_CATEGORY">
          </app-dynamic-dict>

          <mat-form-field fxFlex="50">
            <mat-label>Nazwa produktu</mat-label>
            <input matInput placeholder="Nazwa produktu" formControlName="productName" [required]="true">
          </mat-form-field>
        </div>

        <div fxLayout="row" fxFlex="100" fxLayoutGap="10px">
          <mat-form-field fxFlex="50">
            <mat-label>Ilość produktu</mat-label>
            <input matInput placeholder="Ilość produktu"
                   type="number"
                   min="0"
                   formControlName="productAmount"
                   [required]="true">
          </mat-form-field>

          <app-dynamic-dict fxFlex="50" label="Magazyn" [required]="false"
                            [control]="warehouseControl"
                            [dictType]="DYNAMIC_DICTIONARY_WAREHOUSE">
          </app-dynamic-dict>
        </div>

        <mat-slide-toggle [formControl]="protocolControl" color="accent">Wymagany protokół</mat-slide-toggle>

      </div>
    </mat-card>

    <mat-card fxFlex="50">
      <div fxLayout="column" fxLayoutGap="10px">
        <h3>Dane zakupu</h3>

        <div fxLayout="row" fxFlex="100" fxLayoutGap="10px">
          <mat-form-field fxFlex="50">
            <mat-label>Cena jednostkowa zakupu</mat-label>
            <input matInput placeholder="Cena jednostkowa zakupu"
                   type="number"
                   min="0"
                   lang="pl"
                   formControlName="productPrice"
                   [required]="protocolControl.value">
          </mat-form-field>

          <app-dict fxFlex="50" dictType="marketing_companies" label="Firma"
                    [control]="companyControl"
                    [required]="protocolControl.value"></app-dict>
        </div>

        <div fxLayout="row" fxLayoutGap="10px" fxFlex="100">
          <div fxLayout="row" fxFlex="50">
            <app-datepicker
              fxFlex="100"
              label="Data zakupu"
              placeholder="2000-01-01 00:00"
              [required]="protocolControl.value"
              [control]="purchaseDateControl"
            ></app-datepicker>
          </div>

          <div fxLayout="row" fxFlex="50">
            <app-datepicker
              fxFlex="100"
              label="Data ważności"
              placeholder="2000-01-01 00:00"
              [required]="false"
              [control]="expirationDateControl"
            ></app-datepicker>
          </div>
        </div>

      </div>
    </mat-card>
  </div>

  <div fxFlex="100" fxLayout="row" fxLayoutGap="10px">
    <mat-card fxFlex="50">
      <div fxFlex="100" fxLayout="column" fxLayoutGap="10px">
        <h3>Uwagi</h3>
        <mat-form-field fxFlex="100">
          <mat-label>Uwagi</mat-label>
          <input matInput placeholder="Uwagi" formControlName="note" [required]="false">
        </mat-form-field>
      </div>
    </mat-card>
  </div>

  <div class="buttons" fxLayout="row" fxLayoutGap="15px">
    <button tabindex="-1" (click)="sendForm()" [class.spinner]="processingRequest"
            [disabled]="!productForm.valid || processingRequest"
            mat-stroked-button color="primary">
      <mat-icon>save</mat-icon> <span> Zapisz</span>
    </button>
    <button tabindex="-1" (click)="cancel()" mat-stroked-button color="warn">
      <mat-icon>cancel</mat-icon> <span> Anuluj</span>
    </button>
  </div>
</div>
